import React from 'react'
import styled from 'styled-components'
import LoadingBar from 'react-top-loading-bar'

import { HEADER_HEIGHT } from '@app/ui/theme/constants'
import theme from '@app/ui/theme'

interface HorizontalProgressBarProps {
  progressPercentage: number
}

const StyledProgressBar = styled(LoadingBar)`
  &.loading-bar {
    position: absolute !important;
    top: ${HEADER_HEIGHT - 0.3}rem !important;
  }
`

export const HorizontalProgressBar = ({ progressPercentage }: HorizontalProgressBarProps) => {
  return (
    <StyledProgressBar
      className="loading-bar"
      color={theme.global.colors.sunglow}
      height={3}
      progress={progressPercentage}
      shadow={false}
      transitionTime={100}
      loaderSpeed={100}
      waitingTime={1000 * 100}
    />
  )
}

export default HorizontalProgressBar
